import React from 'react';
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";

// グループの招待ナビゲーション
export const InvitationNavigation = () => {
  const {
    invitedAccountGroups,
  } = useAccountGroupsContext();
  const {
    setOpenHomeModal,
    setOpenMyDataModal,
  } = useModalContext();
  const hasInvitations = invitedAccountGroups.length > 0;
  return (
    <nav className={`info_invitation ${hasInvitations ? 'active' : ''}`} title="グループの招待">
      <BaseRoundButton
      className="open-modal"
        buttonText={`招待されました  ${invitedAccountGroups.length}件`}
        isActive={hasInvitations}
        onClick={() => {
          setOpenHomeModal("ShareInvited");
          setOpenMyDataModal("ShareInvited");
        }}
      />
    </nav>
  );
};